// 社員側のテーマ制御。
// アプリ内に切替UIは持たず、スマートフォン（OS）のダークモード設定にそのまま追従する。
// 管理画面は対象外で常にライト固定。

const DARK_QUERY = "(prefers-color-scheme: dark)";

// ダーク配色を用意済みの画面だけに適用する。
// 未対応画面にダークを当てると白背景×白文字などで読めなくなるため、
// OS がダークでもここに無いパスはライトのまま表示する。
// 配色を追加したらパスもここに足すこと。
// 除外している画面と理由：
//   /card_front      … 社員証は白いカードで見せる画面なのでライト固定
//   /worktime/application … 残業・早退・遅刻申請。インラインstyleでライト配色が
//                           直書きされており、ダークにすると文字が読めない
//   /selected-forms  … 休日出勤・日帰り等の各種申請フォーム。同上
const DARK_READY_PATHS = [
  /^\/worktime\/?$/,            // 勤怠
  /^\/worktime\/record\/?$/,    // 実績（EmployeeTime.css に元からダーク配色あり）
  /^\/applications\/?$/,        // 申請メニュー
  /^\/applications\/history\/?$/, // 申請履歴
];

export function isDarkReadyPath(pathname) {
  const path = String(pathname || "");
  return DARK_READY_PATHS.some((re) => re.test(path));
}

/** OS 側がダーク設定かどうか */
export function prefersDark() {
  try {
    return window.matchMedia(DARK_QUERY).matches;
  } catch {
    return false;
  }
}

/** <html data-theme="dark"> の付け外し。active=false なら常にライト表示に戻す。 */
export function applyTheme(dark, active) {
  const el = document.documentElement;
  if (active && dark) el.setAttribute("data-theme", "dark");
  else el.removeAttribute("data-theme");
}

/** OS のダークモード切替の購読（設定変更に即座に追従させるため） */
export function subscribeSystemTheme(listener) {
  let mql;
  try {
    mql = window.matchMedia(DARK_QUERY);
  } catch {
    return () => {};
  }
  const handler = (e) => listener(e.matches);
  // Safari 13 系は addEventListener 未対応なので addListener にフォールバック
  if (mql.addEventListener) {
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }
  mql.addListener(handler);
  return () => mql.removeListener(handler);
}
